{
  "title": "Welcome Back!",
  "subtitle": "Sign in to continue to Inventra",
  "username": "Username or Email",
  "password": "Password",
  "rememberMe": "Remember me",
  "forgotPassword": "Forgot Password?",
  "submit": "Sign In",
  "authenticating": "Signing in...",
  "footer": "Secure. Reliable. Always.",
  "invalidCredentials": "Invalid username or password.",
  "validation": {
    "usernameRequired": "Username or email is required.",
    "passwordRequired": "Password is required.",
    "emailRequired": "Email is required.",
    "emailInvalid": "Enter a valid email address.",
    "passwordMinLength": "Password must be at least 6 characters.",
    "confirmPasswordRequired": "Please confirm your new password.",
    "passwordsMustMatch": "Passwords do not match."
  },
  "forgotPasswordPage": {
    "title": "Forgot Password?",
    "subtitle": "Enter your email and we'll send you a reset link",
    "emailPlaceholder": "Email address",
    "submit": "Send Reset Link",
    "sending": "Sending...",
    "backToLogin": "Back to Login",
    "checkEmailTitle": "Check Your Email",
    "checkEmailSubtitle": "If an account exists for that email, we've sent a link to reset your password."
  },
  "resetPasswordPage": {
    "title": "Reset Password",
    "subtitle": "Enter your new password below",
    "newPassword": "New Password",
    "confirmPassword": "Confirm New Password",
    "submit": "Reset Password",
    "submitting": "Resetting...",
    "successTitle": "Password Reset",
    "successSubtitle": "Your password has been reset successfully. Redirecting to sign in...",
    "invalidLinkTitle": "Invalid Link",
    "invalidLinkSubtitle": "This password reset link is missing or invalid. Please request a new one."
  },
  "tagline": {
    "line1Plain": "Smarter",
    "line1Bold": "Inventory.",
    "line2Plain": "Stronger",
    "line2Bold": "Business.",
    "line3Plain": "Better",
    "line3Bold": "Tomorrow.",
    "subtitleLine1": "Track. Manage. Optimize.",
    "subtitleLine2": "All your inventory. All in one place."
  },
  "features": {
    "tracking": "Real-time Tracking",
    "analytics": "Smart Analytics",
    "management": "Efficient Management",
    "security": "Secure & Reliable"
  }
}
